module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("The Big Book of Gross Stuff")]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_vm._v("A Note on the Writing of this Book")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02"
    }
  }, [_vm._v("What Makes It Gross?")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch03"
    }
  }, [_vm._v("Gross Quiz!")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Miracle of Birth")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Stream of Life")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Animals!")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breaking the Wind")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monsters! ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Everyone Poops")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s a Gross Job, But I Don’t Want to Do It!")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toilets!")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Putting Your Best Food Forward")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sewers!")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gross Anatomy")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s a Gross World, After All!")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Skin You’re In")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Food, Drink, and Other Harmless Hazards")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kicking the Bucket")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-425e16fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01toc.vue
// module id = 66
// module chunks = 0